<template>
    <div class="d-flex flex-row pt-1">
        <div class="pt-2 mr-2">Per Page</div>
        <multiselect class="cursor-pointer" style="width: fit-content;" v-model="currentValue" :options="perPageOptions" ref="perPageOption"
            @input="changePerPage" :placeholder="currentValue.toString()"
            :show-labels="false" :allow-empty="false" :hide-selected="true" :searchable="false"></multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    name: "users",

    props: {
        perPage: {
            type: Number,
            default: 10,
        }
    },

    components: {
        Multiselect,
    },

    data() {
        return {
            currentValue: 10,
            perPageOptions: [
                10,
                20,
                30,
                40,
                50,
                100,
                200,
            ],
        }
    },

    created() {
    },

    mounted() {
        if (this.perPage) {
            this.currentValue = this.perPage;
        }
    },

    computed: {
    },

    methods: {
        changePerPage() {
            this.$emit('update', this.currentValue);
        },
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .cursor-pointer {
        cursor: pointer;
    }
</style>
